import {Component, inject, OnInit} from '@angular/core';
import {ModalComponent} from 'app/core/modal.component';
import {AppService} from '@services/app.service';
import {ModalService} from '@services/modal.service';

// DON'T FORGET INCLUDE MODULE OF MODAL INTO PAGE MODULE, or it will not work
@Component({
  selector: 'app-update-modal',
  templateUrl: 'item.html',
  styleUrls: ['item.scss'],
})
export class UpdateModalComponent extends ModalComponent {
  appService = inject(AppService);
  modalService = inject(ModalService);
  title = 'Обновите приложение';
  text = 'Обещаем, станет еще лучше!';
  cancelText = 'Позже';
  confirmText = 'Обновить';
  version: {
    ios?: string;
    android?: string;
    googlePlayUrl?: string;
    appStoreUrl?: string;
    critical?: string;
    text?: string;
    btn?: string;
  } = null;

  closeModal(answer: boolean = false) {
    return super.closeModal({answer});
  }

  marketLink() {
    if (this.appService.isIos()) {
      return this.version.appStoreUrl;
    } else {
      return this.version.googlePlayUrl;
    }
  }

  openQrOrCancel() {
    if (this.version.critical === '2') {
      this.modalService.closeAllModals();
      this.navigationService.goTo('update', {}, true, this.version);
    } else {
      this.closeModal();
    }
  }
}
